import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const globalTopMessagePropsSelector = createSelectorPathBuilder(
  (state) => state.globalTopMessage.message,
  (props) => props || {}
)
